import React from 'react';
import styles from './Flyout.module.css';
import { CloseIcon } from '../icons';

/** The card a tool's options open in, beside the dock. */
const Flyout = ({ title, onClose, children }) => (
    <div className={styles.flyout} role="dialog" aria-label={title}>
        <div className={styles.header}>
            <span className={styles.title}>{title}</span>
            <button type="button" className={styles.close} onClick={onClose} aria-label={`Close ${title.toLowerCase()}`}>
                <CloseIcon />
            </button>
        </div>
        {children}
    </div>
);

export default Flyout;
